window.theme = window.theme || {};
window.theme.menuDrawerDesktopTrigger =
  window.theme.menuDrawerDesktopTrigger || 'hover'; // set to 'click' to switch desktop menus to click

const SLIDESHOW_ARROW_SVG =
  '<svg viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation"><path d="M1.77324 18.061L0.6875 16.9335L8.7731 9.11932L0.6875 1.33648L1.77324 0.208984L11.0281 9.1141L1.77324 18.061Z" fill="currentColor"/></svg>';

window.theme.renderSlideshowArrowIcon = function (
  direction = 'right',
  size = 'x-small'
) {
  const prevClass = direction === 'left' ? ' icon-slideshow-arrow--prev' : '';

  return `<span class="icon-slideshow-arrow icon-slideshow-arrow--${size}${prevClass}">${SLIDESHOW_ARROW_SVG}</span>`;
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "button, summary, a[href], button:enabled, [role='button'], [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  // Skip if this summary is inside a drawer-disclosure component
  if (summary.closest('drawer-disclosure')) return;

  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

    console.log(event);
    console.log(event.target);
    console.log(last);

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // Find the actual button element (in case we clicked on a child element)
    const button = event.target.closest('button');
    const buttonName = button ? button.name : event.target.name;

    // Debug logging to help identify the issue
    console.log('Button clicked:', buttonName, 'Target:', event.target.name);

    // Check if it's a plus button (more robust check)
    if (buttonName === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Commonly Used JS Functions
 *
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), wait);
    }
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.utils = function () {};

Shopify.utils.prototype = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

Shopify.currency = function () {};

Shopify.currency.prototype = {
  formatMoney: function (cents, format) {
    var moneyFormat = '${{amount}}';

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = new Shopify.utils().defaultTo(precision, 2);
      thousands = new Shopify.utils().defaultTo(thousands, ',');
      decimal = new Shopify.utils().defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

window.theme.formatMoney = function (cents, format) {
  const moneyFormat = format || window.theme.moneyFormat;
  const formatted = new Shopify.currency().formatMoney(cents, moneyFormat);
  return formatted.replace(/\.00(?!\d)/, '');
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const triggerAttribute = (
      this.getAttribute('data-activate-on') || ''
    ).toLowerCase();
    const configuredTrigger =
      triggerAttribute &&
      typeof window.theme.menuDrawerDesktopTrigger === 'string'
        ? window.theme.menuDrawerDesktopTrigger.toLowerCase()
        : null;
    this.triggerMode = (
      configuredTrigger || triggerAttribute || 'click'
    ).toLowerCase();
    this.activateOnHover = this.triggerMode === 'hover';
    if (triggerAttribute && this.triggerMode !== triggerAttribute) {
      this.setAttribute('data-activate-on', this.triggerMode);
    }
    this.hoverOpenDelay = Number(
      this.getAttribute('data-hover-open-delay') || 20
    );
    this.hoverCloseDelay = Number(
      this.getAttribute('data-hover-close-delay') || 60
    );
    this.hoverOpenTimeout = null;
    this.closeTimeout = null;
    this.menuOverlay = document.querySelector('[data-header-menu-overlay]');

    if (this.menuOverlay && !this.menuOverlay.hasAttribute('data-overlay-bound')) {
      this.menuOverlay.setAttribute('data-overlay-bound', 'true');
      this.menuOverlay.addEventListener('click', () => {
        document
          .querySelectorAll('menu-drawer[data-activate-on="hover"]')
          .forEach(drawer => {
            if (
              drawer.mainDetailsToggle &&
              drawer.mainDetailsToggle.hasAttribute('open')
            ) {
              drawer.closeMenuDrawer();
            }
          });
      });
    }

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));

    // Capture link clicks at the earliest possible moment
    this.mainDetailsToggle.addEventListener(
      'click',
      event => {
        const link = event.target.closest('a');
        // Allow links inside summary to navigate (parent links)
        if (link && link.closest('summary')) {
          // Let the link navigate normally, but close menu after navigation
          const summary = link.closest('summary');
          const detailsElement = summary ? summary.closest('details') : null;
          if (detailsElement && detailsElement.hasAttribute('open')) {
            // Close menu after a short delay to allow navigation
            setTimeout(() => {
              const headerDrawer = this.closest('header-drawer');
              if (headerDrawer) {
                headerDrawer.closeMenuDrawer(
                  event,
                  headerDrawer.querySelector('summary')
                );
              } else {
                this.closeMenuDrawer(event, summary);
              }
            }, 100);
          }
          return; // Allow default link behavior
        }
        if (link && !link.closest('summary')) {
          if (link.closest('[data-drawer-content]')) {
            return;
          }
          // Don't let the click reach the details element
          event.preventDefault();
          event.stopPropagation();
          // Navigate to the link's URL
          window.location.href = link.href;
        }
      },
      true
    ); // Use capture phase to handle before other listeners

    this.bindEvents();
    document.addEventListener('click', event => {
      if (
        !this.contains(event.target) &&
        this.mainDetailsToggle.hasAttribute('open')
      ) {
        this.closeMenuDrawer(event);
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  bindEvents() {
    const activateOnHover = this.activateOnHover;

    if (!activateOnHover) {
    // Always bind click events for the main summary (first one)
    this.querySelectorAll('summary')[0].addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
  }
    
    // Always bind close button clicks
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.menu-drawer__subpanel-nav):not(.menu-drawer__subpanel-overlay)'
    ).forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

    // If hover is enabled, also bind hover events
    if (activateOnHover) {
      this.querySelectorAll('summary').forEach(summary => {
        const detailsElement = summary.closest('details');
        if (!detailsElement) return;

        summary.addEventListener('mouseenter', () => {
          this.handleSummaryHover(summary);
        });

        summary.addEventListener('focusin', () => {
          this.handleSummaryHover(summary, { delay: 0 });
        });

        detailsElement.addEventListener('mouseenter', () => {
          this.cancelHoverIntents();
        });

        detailsElement.addEventListener('mouseleave', event => {
          this.handleHoverRegionMouseLeave(event, detailsElement);
        });

        [
          detailsElement.querySelector('.mega-menu__content'),
          detailsElement.querySelector('.header__mega-menu'),
          detailsElement.querySelector('.header__submenu'),
        ]
          .filter(Boolean)
          .forEach(region => {
            region.addEventListener('mouseenter', () => {
              this.cancelHoverIntents();
            });

            region.addEventListener('mouseleave', event => {
              this.handleHoverRegionMouseLeave(event, detailsElement);
            });
          });
      });
    }
  }

  clearHoverOpenIntent() {
    if (this.hoverOpenTimeout) {
      clearTimeout(this.hoverOpenTimeout);
      this.hoverOpenTimeout = null;
    }
  }

  clearHoverCloseIntent() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  cancelHoverIntents() {
    this.clearHoverOpenIntent();
    this.clearHoverCloseIntent();
  }

  anyDrawerOpen() {
    return Array.from(
      document.querySelectorAll('menu-drawer')
    ).some(drawer => {
      const details = drawer.mainDetailsToggle || drawer.querySelector('details');
      return (
        details &&
        details.hasAttribute('open') &&
        details.classList.contains('menu-open')
      );
    });
  }

  handleSummaryHover(summary, options = {}) {
    const delay =
      typeof options.delay === 'number' ? options.delay : this.hoverOpenDelay;
    this.cancelHoverIntents();
    const detailsElement = summary.closest('details');
    if (!detailsElement || detailsElement.hasAttribute('open')) {
      return;
    }

    this.hoverOpenTimeout = setTimeout(() => {
      this.hoverOpenTimeout = null;
      this.onSummaryClick({ currentTarget: summary, target: summary }, true);
    }, delay);
  }

  handleHoverRegionMouseLeave(event, detailsElement) {
    if (!detailsElement) return;
    const related = event.relatedTarget;

    if (related && detailsElement.contains(related)) {
      return;
    }

    this.scheduleHoverClose(detailsElement);
  }

  scheduleHoverClose(detailsElement) {
    if (!this.activateOnHover || !detailsElement) return;
    if (!detailsElement.hasAttribute('open')) return;

    this.clearHoverCloseIntent();
    this.closeTimeout = setTimeout(() => {
      this.closeTimeout = null;
      if (!this.isHoverWithin(detailsElement)) {
        this.closeMenuDrawer();
      }
    }, this.hoverCloseDelay);
  }

  isHoverWithin(detailsElement) {
    if (!detailsElement) return false;

    return (
      detailsElement.matches(':hover') ||
      Boolean(
        detailsElement.querySelector(
          '.header__mega-menu:hover, .header__submenu:hover, .mega-menu__content:hover'
        )
      )
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event, pIsHover) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const linkElement = event.target.closest('a');

    if (linkElement) {
      // Don't interfere with link clicks
      event.stopPropagation();
      // Let the link navigation happen first, then close menus
      requestAnimationFrame(() => {
        const headerDrawer = this.closest('header-drawer');
        if (headerDrawer) {
          headerDrawer.closeMenuDrawer(
            event,
            headerDrawer.querySelector('summary')
          );
        } else {
          this.closeMenuDrawer(event, summaryElement);
        }
      });
      return;
    }

    if (pIsHover) {
      if (!isOpen) {
        detailsElement.setAttribute('open', 'true');
      } else {
        return;
      }
    }

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      // Only prevent default if it's not a link and the menu is open
      const isLink = event.target.closest('a');
      if (isOpen && !isLink && event.target.tagName !== 'A') {
        event.preventDefault();
      }
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      const isNestedLink = event.target.closest('a');
      if (isNestedLink) return;

      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('menu-close');
        detailsElement.classList.add('menu-open');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');

        if (!this.activateOnHover) {
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener(
                'transitionend',
                addTrapFocus
              );
        }
      }, 100);
      // } else {
      //   this.closeSubmenu(detailsElement);
      // }
    }
  }

  showMenuOverlay() {
    if (!this.menuOverlay || !this.activateOnHover) return;

    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader?.updateStickyHeaderBottom) {
      stickyHeader.updateStickyHeaderBottom();
    }

    this.menuOverlay.classList.add('is-active');
    this.menuOverlay.setAttribute('aria-hidden', 'false');
  }

  hideMenuOverlay() {
    if (!this.menuOverlay) return;
    if (this.anyDrawerOpen()) return;

    this.menuOverlay.classList.remove('is-active');
    this.menuOverlay.setAttribute('aria-hidden', 'true');
  }

  openMenuDrawer(summaryElement) {
    // Close other open menu drawers
    document.querySelectorAll('details[open]').forEach(openDetails => {
      if (openDetails !== summaryElement.parentNode) {
        this.closeSubmenu(openDetails);
      }
    });

    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('menu-close');
      this.mainDetailsToggle.classList.add('menu-open');
    });

    this.showMenuOverlay();

    // Remove this line - let DrawerDisclosure handle aria-expanded
    // summaryElement.setAttribute('aria-expanded', true);

    if (!this.activateOnHover) {
      trapFocus(this.mainDetailsToggle, summaryElement);
    }
    if (this.dataset.breakpoint) {
      document.body.classList.add(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
    }
  }

  closeMenuDrawer(event, elementToFocus = false, pIsHover = false) {
    if (event === undefined && !this.activateOnHover) return;

    this.cancelHoverIntents();

    // Add closing class for animation
    const menuPanels = this.mainDetailsToggle.querySelectorAll('.header__mega-menu, .header__submenu');
    
    menuPanels.forEach(panel => {
      panel.classList.add('closing');
    });

    // Wait for animation to complete before actually closing
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('menu-open');
      this.mainDetailsToggle.classList.add('menu-close');
      
      menuPanels.forEach(panel => {
        panel.classList.remove('closing');
      });

      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-open');
        details.classList.add('menu-close');
      });
      this.mainDetailsToggle
        .querySelectorAll('.submenu-open')
        .forEach(submenu => {
          submenu.classList.remove('submenu-open');
        });
      document.body.classList.remove('overflow-hidden');
      if (this.dataset.breakpoint) {
        document.body.classList.remove(
          `overflow-hidden-${this.dataset.breakpoint}`
        );
      }
      if (!this.activateOnHover) {
        removeTrapFocus(elementToFocus);
      }
      this.hideMenuOverlay();
    }, 300); // Match the CSS transition duration
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-open');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    if (!this.activateOnHover) {
      removeTrapFocus(detailsElement.querySelector('summary'));
    }
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]') && !this.activateOnHover) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('header');
    if (typeof this.borderOffset !== 'number') {
      const headerWrapper = this.closest('.header-wrapper');
      this.borderOffset =
        headerWrapper && headerWrapper.classList.contains('header-wrapper--border-bottom')
          ? 1
          : 0;
    }

    this.updateDrawerMetrics();

    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('menu-close');
      this.mainDetailsToggle.classList.add('menu-open');
      this.header.classList.add('menu-open');
      this.header.classList.remove('menu-close');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    this.header.classList.add('menu-close');
    this.mainDetailsToggle.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }

  onResize = () => {
    this.updateDrawerMetrics();
  };

  updateDrawerMetrics = () => {
    if (!this.header) return;

    const headerRect = this.header.getBoundingClientRect();
    const borderOffset = this.borderOffset || 0;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${Math.round(headerRect.bottom - borderOffset)}px`
    );
    document.documentElement.style.setProperty(
      '--header-height',
      `${Math.round(headerRect.height)}px`
    );
    document.documentElement.style.setProperty(
      '--viewport-height',
      `${window.innerHeight}px`
    );
  };
}

customElements.define('header-drawer', HeaderDrawer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

const SizeSelection = {
  requiresSelection(container) {
    return container?.dataset?.requiresSizeSelection === 'true';
  },

  isSizeOptionName(name) {
    return (name || '').trim().toLowerCase() === 'size';
  },

  getSelectedVariant(container) {
    try {
      const script = container?.querySelector(
        'variant-selects [data-selected-variant]'
      );
      return script?.textContent ? JSON.parse(script.textContent) : null;
    } catch {
      return null;
    }
  },

  getSizeValueFromVariant(container, variant) {
    if (!variant) return null;

    const sizeControls = this.getSizeControls(container);
    if (!sizeControls) {
      return variant.options?.[0] || variant.option1 || null;
    }

    const sizeValues =
      sizeControls.type === 'radio'
        ? Array.from(
            sizeControls.element.querySelectorAll('input[type="radio"]')
          ).map(input => input.value)
        : Array.from(sizeControls.element.options)
            .map(option => option.value)
            .filter(Boolean);

    const matchedOption = variant.options?.find(option =>
      sizeValues.includes(option)
    );
    if (matchedOption) return matchedOption;

    for (const optionKey of ['option1', 'option2', 'option3']) {
      if (sizeValues.includes(variant[optionKey])) {
        return variant[optionKey];
      }
    }

    const sizeIndex = this.getSizeOptionIndex(container);
    if (sizeIndex >= 0) {
      return variant.options?.[sizeIndex] || null;
    }

    return variant.option1 || null;
  },

  getSizeOptionIndex(container) {
    const variantSelects = container?.querySelector('variant-selects');
    if (!variantSelects) return -1;

    let index = 0;
    for (const node of variantSelects.children) {
      if (node.tagName === 'SCRIPT') continue;

      const isSizeGroup =
        (node.tagName === 'FIELDSET' &&
          this.isSizeOptionName(
            node.querySelector('legend')?.textContent?.trim().split(/\s+/)[0]
          )) ||
        (node.tagName === 'CUSTOM-SELECT-WRAPPER' &&
          this.isSizeOptionName(node.querySelector('label')?.textContent));

      if (isSizeGroup) return index;

      if (
        node.tagName === 'FIELDSET' ||
        node.tagName === 'CUSTOM-SELECT-WRAPPER'
      ) {
        index++;
      }
    }

    return -1;
  },

  restoreSizeSelectionFromVariant(container, variant) {
    if (!variant?.options || !this.requiresSelection(container)) return;

    const sizeValue = this.getSizeValueFromVariant(container, variant);
    if (!sizeValue) return;

    const sizeControls = this.getSizeControls(container);
    if (!sizeControls) return;

    if (sizeControls.type === 'radio') {
      const radio = Array.from(
        sizeControls.element.querySelectorAll('input[type="radio"]')
      ).find(input => input.value === sizeValue);

      if (!radio) return;

      radio.checked = true;

      const selectedValue = sizeControls.element.querySelector(
        '[data-selected-value]'
      );
      if (selectedValue) selectedValue.textContent = sizeValue;
      return;
    }

    const matchingOption = Array.from(sizeControls.element.options).find(
      option => option.value === sizeValue
    );
    if (matchingOption) {
      sizeControls.element.value = sizeValue;
    }
  },

  getSizeControls(container) {
    const variantSelects = container?.querySelector('variant-selects');
    if (!variantSelects) return null;

    const fieldset = Array.from(
      variantSelects.querySelectorAll('fieldset.product-form__input--pill')
    ).find(fieldsetEl => {
      const legendText = fieldsetEl
        .querySelector('legend')
        ?.textContent?.replace(/\s+/g, ' ')
        .trim()
        .split(' ')[0];
      return this.isSizeOptionName(legendText);
    });

    if (fieldset) {
      return { type: 'radio', element: fieldset };
    }

    const select = Array.from(
      variantSelects.querySelectorAll('select.select__select')
    ).find(selectEl => {
      const label = variantSelects.querySelector(
        `label[for="${selectEl.id}"]`
      );
      return this.isSizeOptionName(label?.textContent);
    });

    if (select) {
      return { type: 'select', element: select };
    }

    return null;
  },

  isSizeSelected(container) {
    if (!this.requiresSelection(container)) return true;

    const sizeControls = this.getSizeControls(container);
    if (!sizeControls) return true;

    if (sizeControls.type === 'radio') {
      return Boolean(
        sizeControls.element.querySelector('input[type="radio"]:checked')
      );
    }

    return (
      sizeControls.element.value !== '' &&
      !sizeControls.element.selectedOptions[0]?.hasAttribute('disabled')
    );
  },

  areAllSizesSoldOut(container) {
    const sizeControls = this.getSizeControls(container);
    if (!sizeControls) return false;

    if (sizeControls.type === 'radio') {
      const radios = sizeControls.element.querySelectorAll('input[type="radio"]');
      if (!radios.length) return false;

      return Array.from(radios).every(
        input =>
          input.disabled ||
          input.classList.contains('disabled') ||
          input.getAttribute('aria-disabled') === 'true'
      );
    }

    const options = Array.from(sizeControls.element.options).filter(
      option => option.value !== ''
    );
    if (!options.length) return false;

    return options.every(option => option.disabled);
  },

  getSelectedSizeInput(container) {
    const sizeControls = this.getSizeControls(container);
    if (!sizeControls) return null;

    if (sizeControls.type === 'radio') {
      return sizeControls.element.querySelector('input[type="radio"]:checked');
    }

    return sizeControls.element.selectedOptions[0] || null;
  },

  resetSizeSelection(container) {
    const sizeControls = this.getSizeControls(container);
    if (!sizeControls) return;

    if (sizeControls.type === 'radio') {
      sizeControls.element
        .querySelectorAll('input[type="radio"]:checked')
        .forEach(input => {
          input.checked = false;
        });

      const selectedValue = sizeControls.element.querySelector(
        '[data-selected-value]'
      );
      if (selectedValue) selectedValue.textContent = '';
      return;
    }

    const placeholder = sizeControls.element.querySelector(
      'option[value=""][disabled]'
    );
    if (placeholder) {
      sizeControls.element.value = '';
      placeholder.selected = true;
    }
  },

  updateVariantInputs(container, variantId = '') {
    const sectionId = container?.dataset?.section;
    if (!sectionId) return;

    container
      .querySelectorAll(
        `#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`
      )
      .forEach(form => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;

        input.value = variantId;
        if (variantId) {
          input.removeAttribute('disabled');
        } else {
          input.setAttribute('disabled', 'disabled');
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  },

  updateBuyButtons(container) {
    if (!this.requiresSelection(container)) return;

    const productForm = container.querySelector('product-form');
    const submitButton = container.querySelector(
      `#ProductSubmitButton-${container.dataset.section}`
    );
    const stickySubmitButton = document.querySelector(
      `#ProductSubmitButtonSticky-${container.dataset.section}`
    );
    const submitButtons = [submitButton, stickySubmitButton].filter(Boolean);

    if (!submitButtons.length) return;

    const setButtonState = (button, disable, text) => {
      const textEl =
        button.querySelector('.product-form__submit-text') ||
        button.querySelector('span');
      if (disable) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        if (text && textEl) textEl.textContent = text;
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        if (textEl) {
          textEl.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }
    };

    if (!this.isSizeSelected(container)) {
      this.updateVariantInputs(container, '');

      if (this.areAllSizesSoldOut(container)) {
        submitButtons.forEach(button =>
          setButtonState(
            button,
            true,
            window.variantStrings?.soldOut || 'Sold out'
          )
        );
        window.KlaviyoBis?.updateVisibility(container);
        return;
      }

      submitButtons.forEach(button =>
        setButtonState(
          button,
          true,
          window.variantStrings?.selectASize || 'Select a size'
        )
      );
      window.KlaviyoBis?.updateVisibility(container);
      return;
    }

    const selectedSizeInput = this.getSelectedSizeInput(container);
    const selectedSizeValue = selectedSizeInput?.value;
    const selectedVariant = this.getSelectedVariant(container);
    const variantSizeValue = this.getSizeValueFromVariant(
      container,
      selectedVariant
    );
    const variantMatchesSelection =
      !selectedSizeValue ||
      !variantSizeValue ||
      selectedSizeValue === variantSizeValue;

    if (
      variantMatchesSelection &&
      selectedVariant &&
      selectedVariant.available === false
    ) {
      submitButtons.forEach(button =>
        setButtonState(
          button,
          true,
          window.variantStrings?.soldOut || 'Sold out'
        )
      );
      this.updateVariantInputs(container, '');
      window.KlaviyoBis?.updateVisibility(container);
      return;
    }

    if (
      variantMatchesSelection &&
      selectedVariant?.available === true &&
      selectedVariant.id
    ) {
      submitButtons.forEach(button => setButtonState(button, false));
      this.updateVariantInputs(container, String(selectedVariant.id));
      window.KlaviyoBis?.updateVisibility(container);
      return;
    }

    const isSoldOut =
      selectedSizeInput?.disabled ||
      selectedSizeInput?.classList?.contains('disabled') ||
      selectedSizeInput?.getAttribute('aria-disabled') === 'true';

    if (isSoldOut) {
      submitButtons.forEach(button =>
        setButtonState(
          button,
          true,
          window.variantStrings?.soldOut || 'Sold out'
        )
      );
      this.updateVariantInputs(container, '');
      window.KlaviyoBis?.updateVisibility(container);
      return;
    }

    if (!variantMatchesSelection) {
      submitButtons.forEach(button => setButtonState(button, true));
      this.updateVariantInputs(container, '');
      window.KlaviyoBis?.updateVisibility(container);
      return;
    }

    const variantId =
      productForm?.variantIdInput?.value ||
      container.querySelector('input[name="id"]')?.value ||
      '';

    if (!variantId) {
      submitButtons.forEach(button => setButtonState(button, true));
      this.updateVariantInputs(container, '');
      window.KlaviyoBis?.updateVisibility(container);
      return;
    }

    submitButtons.forEach(button => setButtonState(button, false));
    this.updateVariantInputs(container, variantId);

    window.KlaviyoBis?.updateVisibility(container);
  },
};

window.SizeSelection = SizeSelection;

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', event => {
      const input = event.target.closest('.product-form__input--pill')?.querySelector(
        'input[type="radio"]'
      );
      if (input?.disabled || input?.classList.contains('disabled')) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    this.addEventListener('change', event => {
      if (
        event.target.disabled ||
        event.target.classList?.contains('disabled')
      ) {
        return;
      }

      if (this.closest('product-info')?.hasAttribute('data-variant-selects-updating')) {
        return;
      }

      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      // Update variant input synchronously before async fetch completes
      this.updateVariantInputSync();

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });

      const productInfo = this.closest('product-info');
      if (productInfo?.dataset?.requiresSizeSelection === 'true') {
        SizeSelection.updateBuyButtons(productInfo);
      }
    });
  }

  /**
   * Update variant input synchronously based on selected option values
   * This ensures the correct variant ID is in the form even if user clicks
   * "Add to Cart" before the async fetch completes
   */
  updateVariantInputSync() {
    const selectedOptionValues = this.selectedOptionValues;
    if (!selectedOptionValues || selectedOptionValues.length === 0) return;

    // Fetch variant ID immediately based on selected option value IDs
    // This runs in parallel with the product-info async update
    this.fetchVariantIdByOptionValues(selectedOptionValues);
  }

  /**
   * Get the original section ID (for server requests)
   * This matches the logic in product-info.js
   */
  get originalSectionId() {
    const productInfo = this.closest('product-info');
    if (productInfo && productInfo.dataset.originalSection) {
      return productInfo.dataset.originalSection;
    }
    return this.dataset.section;
  }

  /**
   * Fetch variant ID based on selected option value IDs
   * Uses the same approach as product-info.js but runs immediately
   */
  async fetchVariantIdByOptionValues(selectedOptionValueIds) {
    const productInfo = this.closest('product-info');
    if (!productInfo) return;

    const productUrl = productInfo.dataset.url || window.location.pathname;
    // Use original section ID for the fetch request (what the server expects)
    const sectionId = this.originalSectionId;

    // Build URL with option value IDs (same format as product-info.js)
    const optionValuesParam = selectedOptionValueIds.join(',');
    const url = `${productUrl}?option_values=${optionValuesParam}&section_id=${sectionId}`;

    try {
      const response = await fetch(url);
      if (productUrl !== productInfo.dataset.url) return;

      const html = await response.text();
      if (productUrl !== productInfo.dataset.url) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Get the selected variant from the response
      const variantSelects = doc.querySelector('variant-selects');
      if (variantSelects) {
        const variantScript = variantSelects.querySelector('[data-selected-variant]');
        if (variantScript) {
          const variant = JSON.parse(variantScript.textContent);
          if (variant && variant.id) {
            this.updateVariantInputValue(variant.id);
          }
        }
      }
    } catch (error) {
      // Silently fail - product-info.js will handle the update
      console.error('Error fetching variant ID:', error);
    }
  }

  getFormUpdateRoot() {
    return this.closest('product-info') || document;
  }

  /**
   * Update the hidden variant input value
   */
  updateVariantInputValue(variantId) {
    const sectionId = this.dataset.section;
    const productInfo = this.getFormUpdateRoot();
    const productForms = productInfo.querySelectorAll(
      `#product-form-${sectionId}, #product-form-installment-${sectionId}`
    );

    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = variantId;
        input.removeAttribute('disabled');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    if (
      productInfo?.matches?.('product-info') &&
      window.SizeSelection?.requiresSelection(productInfo)
    ) {
      window.SizeSelection.updateBuyButtons(productInfo);
    }
  }

  updateSelectionMetadata({ target }) {
    const { tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      if (target.options[0].getAttribute('selected')) {
        Array.from(target.options)
          .find(option => option.getAttribute('selected'))
          .removeAttribute('selected');
        target.selectedOptions[0].setAttribute('selected', 'selected');
      }

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          swatchValue
        );
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          '--swatch--background',
          'unset'
        );
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = target.value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll('select option[selected], fieldset input:checked')
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.setUpEvents();
  }

  /**
   * Override to also update variant using VariantRadios methods
   * when variant data is available
   */
  updateVariantInputSync() {
    // Call parent method first (handles async fetch)
    super.updateVariantInputSync();

    // Also try to update using VariantRadios methods if we have variant data
    this.updateOptions();
    const variantData = this.getVariantData();
    
    // If we have variant data (array of variants), try to match synchronously
    if (Array.isArray(variantData) && variantData.length > 0) {
      this.updateMasterVariantId();
      if (this.currentVariant && this.currentVariant.id) {
        this.updateVariantInput();
      }
    }
  }

  updateOptions() {
    if (this.querySelectorAll('input[type="radio"]:checked').length > 0) {
      this.options = Array.from(
        this.querySelectorAll('input[type="radio"]:checked'),
        input => input.value
      );
    } else {
      this.options = Array.from(
        this.querySelectorAll('input[type="radio"]'),
        input => input.value
      );
    }
  }

  alertAvailability(pAvailable, pVariant) {
    let productForm = this.getFormUpdateRoot().querySelector(
      `product-form[data-section-id="${this.dataset.section}"], product-form[data-section="${this.dataset.section}"]`
    );

    // Create a custom event
    const notInStockEvent = new CustomEvent('alert-not-in-stock', {
      bubbles: true, // Allow the event to bubble up the DOM tree
      cancelable: true, // Allow the event to be cancelable,
      detail: pVariant,
    });

    // Create a custom event
    const inStockEvent = new CustomEvent('alert-in-stock', {
      bubbles: true, // Allow the event to bubble up the DOM tree
      cancelable: true, // Allow the event to be cancelable
      detail: pVariant,
    });

    //Dispatch Event on product form
    if (pAvailable) {
      productForm.dispatchEvent(inStockEvent);
    } else {
      productForm.dispatchEvent(notInStockEvent);
    }
  }

  toggleAddButton(pSoldOutStatus, pDisableButton) {
    if (
      document.querySelector(
        `[data-product-card][data-section="${this.dataset.section}"]`
      )
    ) {
      let quickAddButton = document
        .querySelector(
          `[data-product-card][data-section="${this.dataset.section}"]`
        )
        .querySelector('quick-add-button')
        .querySelector('button');
      let quickAddButtonText = document
        .querySelector(
          `[data-product-card][data-section="${this.dataset.section}"]`
        )
        .querySelector('quick-add-button')
        .querySelector('span');
      this.toggleQuickAddButton(
        pSoldOutStatus,
        pDisableButton,
        quickAddButton,
        quickAddButtonText
      );
    }

    let productForm = this.getFormUpdateRoot().querySelector(
      `product-form[data-section-id="${this.dataset.section}"], product-form[data-section="${this.dataset.section}"]`
    );

    let disable = pDisableButton;
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (pSoldOutStatus === 'sold-out') {
        addButtonText.textContent = window.variantStrings.soldOut;
      }
      if (pSoldOutStatus === 'variant-sold-out') {
        addButtonText.textContent = window.variantStrings.currentOptionSoldOut;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  updateMasterVariantId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForms = this.getFormUpdateRoot().querySelectorAll(
      `#quick-add-form-${this.dataset.section}, #product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    productForms.forEach(productForm => {
      if (productForm.querySelector('input[name="id"]')) {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ===
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
        ? this.variantData
        : JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
    return this.variantData;
  }

  setSoldOutOptions() {
    let data = {
      productVariants: JSON.parse(
        this.querySelector('[type="application/json"]').innerHTML
      ),
    };

    let allProductVariants = data.productVariants;

    let sizeOptions = [];

    this.querySelectorAll('input').forEach(function (elem) {
      sizeOptions.push(elem);
      elem.parentElement.classList.remove('is-sold-out');
      elem.disabled = false;
      elem.setAttribute('aria-disabled', false);
    });

    for (var i = 0; i < allProductVariants.length; i++) {
      if (allProductVariants[i].available == false) {
        sizeOptions.forEach(elem => {
          if (
            allProductVariants[i].option1 == elem.value ||
            allProductVariants[i].option2 == elem.value
          ) {
            elem.parentElement.classList.add('is-sold-out');
            elem.disabled = true;
            elem.setAttribute('aria-disabled', true);
          }
        });
      }
    }

    if (!this.currentVariant.available) {
      if (
        this.querySelectorAll("input[type='radio']:not([disabled])").length ===
        0
      ) {
        if (this.dataset.isQuickAdd == 'true') {
          this.toggleAddButton('sold-out', true, true);
        }
        this.toggleAddButton('sold-out', true);
      }

      if (
        this.querySelectorAll("input[type='radio']:not([disabled])").length > 0
      ) {
        if (this.dataset.isQuickAdd == 'true') {
          this.toggleAddButton('variant-sold-out', true, true);
        }
        this.toggleAddButton('variant-sold-out', true);
      }
    } else {
      if (this.dataset.isQuickAdd == 'true') {
        this.toggleAddButton(false, false, true);
      }
      this.toggleAddButton(false, false, true);
    }

    this.alertAvailability(this.currentVariant.available, this.currentVariant);
  }

  setUpEvents() {
    if (this.querySelector('[data-current-option]')) {
      let currentOption = this.querySelector(
        '[data-current-option]'
      ).textContent;

      function showOption(pColor) {
        let colorContainer = document.querySelector('[data-current-option]');
        colorContainer.textContent = pColor.replace(/[\n\r]+|[\s]{2,}/g, '');
      }

      this.querySelectorAll('[data-option-label]').forEach(element => {
        element.addEventListener('click', event => {
          let name = event.target.dataset.optionName;
          currentOption = name;
          showOption(name);
        });

        element.addEventListener('mouseenter', event => {
          let name = event.target.dataset.optionName;
          showOption(name);
        });

        element.addEventListener('mouseleave', event => {
          showOption(currentOption);
        });
      });

      this.querySelectorAll('input[type="radio"]').forEach(element => {
        element.addEventListener('focus', event => {
          let name = event.target.value;
          showOption(name);
        });

        element.addEventListener('blur', event => {
          showOption(currentOption);
        });
      });
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class CustomInputWrapper extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    let textFieldWrapper = this;
    let inputElement = this.querySelector('input') || this.querySelector('textarea');

    if (inputElement !== null) {
      inputElement.addEventListener('change', function (event) {
        let input = event.currentTarget;

        if (input.value.length > 0) {
          textFieldWrapper.classList.add('is-active');
        } else {
          textFieldWrapper.classList.remove('is-active');
        }
      });

      let changeEvent = new Event('change');
      inputElement.dispatchEvent(changeEvent);

      inputElement.addEventListener('focus', function () {
        textFieldWrapper.classList.add('is-active');
      });

      inputElement.addEventListener('blur', function (event) {
        let input = event.currentTarget;
        if (input.value.length > 0) {
          textFieldWrapper.classList.add('is-active');
        } else {
          textFieldWrapper.classList.remove('is-active');
        }
      });
    }
  }
}

customElements.define('custom-input-wrapper', CustomInputWrapper);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const selector = this.getAttribute('data-modal');
      let modal = null;

      if (selector?.startsWith('#')) {
        modal = document.getElementById(selector.slice(1));
      } else if (selector) {
        modal = document.querySelector(selector);
      }

      if (!modal) {
        modal = this.closest('.quick-add')?.querySelector(
          'quick-add-modal, quick-add-modal-mobile'
        );
      }

      if (modal && typeof modal.show === 'function') {
        modal.show(button);
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const closeButton = this.querySelector('[id^="ModalClose-"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.hide.bind(this, false));
    }
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = []
  ) {
    preProcessCallbacks?.forEach(callback => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach(element => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          'form',
          `${element.form.getAttribute('id')}-${uniqueKey}`
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach(callback => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class GlobalModal extends HTMLElement {
  constructor() {
    super();

    this.modalId = this.id;
    this.modal =
      this.querySelector('[role="dialog"]') || this.querySelector('dialog');
    this.modalTriggers = document.querySelectorAll(
      `button[data-modal="${this.modalId}"]`
    );
    this.close = this.querySelectorAll('[data-modal-close]');
    //   this.openButton = this.shadowRoot.querySelector('#openModalButton');
    //   this.modal = this.shadowRoot.querySelector('#modal');
    //   this.closeButton = this.shadowRoot.querySelector('#closeModalButton');

    //   this.openButton.addEventListener('click', () => this.openModal());
    //   this.closeButton.addEventListener('click', () => this.closeModal());
    this.initEvents();
  }

  initEvents() {
    this.modalTriggers.forEach(elem => {
      elem.addEventListener('click', event => this.openModal(event));
    });

    this.close.forEach(elem => {
      elem.addEventListener('click', () => this.closeModal());
    });
  }

  openModal(pEvent) {
    if (pEvent) {
      pEvent.target.closest('button').setAttribute('aria-expanded', true);
    }

    this.modal.setAttribute('aria-hidden', 'false');

    if (!this.modal.dataset.allowScroll) {
      document.body.classList.add(`overflow-hidden`);
    }
  }

  closeModal() {
    this.modalTriggers.forEach(elem => {
      elem.setAttribute('aria-expanded', 'false');
    });

    this.modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove(`overflow-hidden`);

    // setTimeout(()=> {
    //   this.modal.style.display = 'none';
    // }, 600);
  }
}

customElements.define('global-modal', GlobalModal);

function loadScript(scriptUrl) {
  const script = document.createElement('script');
  script.src = scriptUrl;
  document.body.appendChild(script);

  return new Promise((res, rej) => {
    script.onload = function () {
      res();
    };
    script.onerror = function () {
      rej();
    };
  });
}

function getAbsoluteHeight(el) {
  // Get the DOM Node if you pass in a string
  el = typeof el === 'string' ? document.querySelector(el) : el;

  var styles = window.getComputedStyle(el);
  var margin =
    parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);

  return Math.ceil(el.offsetHeight + margin);
}

class SearchToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.modal = document.querySelector('[data-search-modal]');
    this.desktopQuery = window.matchMedia('(min-width: 930px)');
    this.onResize = () => this.updateSearchModalMetrics();
    this.isClosing = false;

    if (!this.modal) return;

    this.modal.classList.remove('preload');
    this.applyMode();
    this.setUpEvents();

    this.desktopQuery.addEventListener('change', () => {
      this.applyMode();
      if (this.modal.getAttribute('aria-hidden') === 'false') {
        this.updateSearchModalMetrics();
      }
    });

    document.addEventListener('click', event => {
      if (this.modal.getAttribute('aria-hidden') !== 'false') return;

      const isClickInside = this.modal.contains(event.target);
      const isToggleButton = this.contains(event.target);

      if (!isClickInside && !isToggleButton) {
        this.closeSearch();
      }
    });
  }

  /**
   * Reflects the current viewport mode onto [data-search-mode] so CSS can
   * switch between the dropdown (desktop) and drawer (mobile) layouts.
   */
  applyMode() {
    const mode = this.desktopQuery.matches ? 'dropdown' : 'drawer';
    this.modal.setAttribute('data-search-mode', mode);
  }

  updateSearchModalMetrics() {
    if (this.isDesktop()) return;

    const header = document.querySelector('.header');
    if (!header) return;

    const headerBottom = Math.round(header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty(
      '--search-modal-top',
      `${headerBottom}px`
    );
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${headerBottom}px`
    );
  }

  isDesktop() {
    return this.desktopQuery.matches;
  }

  setUpCloseEvents() {
    document.addEventListener(
      'keyup',
      evt => {
        if (evt.code === 'Escape') this.closeSearch();
      },
      { once: true }
    );
  }

  closeSearch() {
    if (!this.modal || this.isClosing) return;
    if (this.modal.getAttribute('aria-hidden') !== 'false') return;

    this.isClosing = true;
    this.button.setAttribute('aria-expanded', 'false');
    this.modal.setAttribute('aria-hidden', 'true');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.button);
    }

    const panel = this.modal.querySelector('.search-modal__panel');
    const finishClose = () => {
      this.isClosing = false;
      window.removeEventListener('resize', this.onResize);
    };

    if (!panel) {
      finishClose();
      return;
    }

    const onTransitionEnd = event => {
      if (event.target !== panel) return;
      if (
        event.propertyName !== 'transform' &&
        event.propertyName !== 'opacity'
      ) {
        return;
      }
      panel.removeEventListener('transitionend', onTransitionEnd);
      finishClose();
    };

    panel.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(() => {
      if (!this.isClosing) return;
      panel.removeEventListener('transitionend', onTransitionEnd);
      finishClose();
    }, 400);
  }

  openSearch() {
    if (!this.modal || this.isClosing) return;
    this.button.setAttribute('aria-expanded', 'true');
    this.applyMode();
    this.updateSearchModalMetrics();
    window.addEventListener('resize', this.onResize);

    const input = this.modal.querySelector('input[type="search"]');
    const panel = this.modal.querySelector('.search-modal__panel');

    this.modal.setAttribute('aria-hidden', 'false');
    this.setUpCloseEvents();

    if (this.isDesktop() && panel) {
      panel.style.transition = 'none';
      panel.style.opacity = '0';
      panel.getBoundingClientRect();
      panel.style.transition = '';
      panel.style.opacity = '';
    }

    if (this.isDesktop()) {
      if (input) input.focus({ preventScroll: true });
    } else if (typeof trapFocus === 'function') {
      trapFocus(this.modal, input);
    }
  }

  setUpEvents() {
    this.button.addEventListener('click', () => {
      if (this.modal.getAttribute('aria-hidden') === 'false') {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    });

    this.modal.querySelectorAll('[data-modal-close]').forEach(el => {
      el.addEventListener('click', () => this.closeSearch());
    });
  }
}

customElements.define('search-toggle', SearchToggle);

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.stickyHeaderWrapper = this.closest('[data-sticky-header]');
    this.updateStickyHeaderBottomHandler =
      this.updateStickyHeaderBottom.bind(this);
    
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    this.updateStickyHeaderBottom();

    this.mediaQuery = window.matchMedia('(max-width: 940px)');
    this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
    this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);
    window.addEventListener('resize', this.updateStickyHeaderBottomHandler);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = throttle(this.onScroll.bind(this), 16);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.header.offsetHeight}px`
    );
    this.updateStickyHeaderBottom();
  }

  updateStickyHeaderBottom() {
    if (!this.stickyHeaderWrapper) return;

    const rect = this.stickyHeaderWrapper.getBoundingClientRect();
    document.documentElement.style.setProperty(
      '--sticky-header-bottom',
      `${Math.round(rect.bottom)}px`
    );
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.updateStickyHeaderBottomHandler);
    if (this.mediaQuery && this.setHeaderHeightHandler) {
      this.mediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
    }
  }

  createObserver() {
    if (!this.header) return;
    
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.headerIsAlwaysSticky) {
      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
      return;
    }

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );
    this.closeMenuDisclosure();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
}

customElements.define('sticky-header', StickyHeader);

// document.addEventListener('DOMContentLoaded', () => {
//   const observerOptions = {
//     root: null,
//     rootMargin: '0px',
//     threshold: 0.1
//   };

//   const observer = new IntersectionObserver((entries, observer) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const parentElement = entry.target;
//         const textElements = parentElement.querySelectorAll('.animate-text');

//         textElements.forEach((textElement, index) => {
//           const text = textElement.textContent;
//           textElement.textContent = '';

//           for (let i = 0; i < text.length; i++) {
//             const span = document.createElement('span');
//             const char = text[i];
//             const parentTag = textElement.cloneNode(false);
//             parentTag.textContent = '';
//             span.textContent = char;
//             span.style.opacity = 0;
//             span.style.transition = `opacity 1s ease ${(index * 0.5) + (i * 0.1)}s`;
//             parentTag.appendChild(span);
//             textElement.appendChild(parentTag);

//             requestAnimationFrame(() => {
//               span.style.opacity = 1;
//             });
//           }
//         });

//         observer.unobserve(parentElement);
//       }
//     });
//   }, observerOptions);

//   document.querySelectorAll('.anima-text').forEach(element => {
//     observer.observe(element.parentElement);
//   });
// });

class TabbedInterface extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.tabPanels = [];
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length) return;

    this.initTabIndices();

    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.onTabClick.bind(this));
      tab.addEventListener('keydown', this.onTabKeydown.bind(this));
    });
  }

  initTabIndices() {
    let hasSelected = false;

    this.tabs.forEach(tab => {
      const isSelected = tab.getAttribute('aria-selected') === 'true';
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      if (isSelected) hasSelected = true;
    });

    if (!hasSelected && this.tabs[0]) {
      this.activateTab(this.tabs[0]);
    }
  }

  onTabClick(event) {
    this.activateTab(event.currentTarget);
  }

  onTabKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let targetIndex = null;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        targetIndex =
          (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        targetIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'Home':
        event.preventDefault();
        targetIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        targetIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    this.activateTab(this.tabs[targetIndex]);
    this.tabs[targetIndex].focus();
  }

  activateTab(tab) {
    this.tabs.forEach(item => {
      const isActive = item === tab;
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.tabPanels.forEach(panel => {
      panel.hidden = true;
    });

    const panelId = tab.getAttribute('aria-controls');
    const panel = panelId ? this.querySelector(`#${panelId}`) : null;
    if (panel) panel.hidden = false;
  }
}

customElements.define('tabbed-interface', TabbedInterface);
